
import React from "react";
import Profile from "./Profile";
import './SideMenu.scss';
import closeIcon from '../assets/icons/menu_close_icon.svg'
import { reactLocalStorage } from "reactjs-localstorage";
// import logo from "../assets/icons/textlogo.png"

function SideMenu({ sideMenu, handleClose, menuLogo, menuColor,showMenu }) {
  console.log("Sidemneu insdie")
  return (
    <>
      {true && (
        <>
        {console.log("The sidemenu component")}
         
        </>
      )}
    </>
  );
}

export default SideMenu